export enum PresMusic {
    "",
    "火-《佛光》-静心安神补气",
    "火-《碧涧流泉》-安神洗涤心尘",
    "火-《平沙落雁》-妙音佳曲安神",
    "火-《此生彼岸》-疏肝补元贮能",
    "火-《山水情》-养心疏肝洗心尘",
    "火-《初心》-静心安神补气",
    "火-《云水逸》-养心安神静心",
    "火-《普安咒》-安稳身心百害不侵",
    "火-《落雪听禅》-养心安神气血平和",
    "火-《只生欢喜不生愁》-安稳身心静心",
    "火-《听云》-滋补气血静心",
    "火-《徵音之光》-补脾利肺宁心",
    "火-《浮光》-调理神志疏导血脉",
    "火-《荷花映日》-徵调阳（心属火）",
    "火-《欢沁》-缓解胸闷",
    "火-《金蛇狂舞》-愉悦心情",
    "火-《兰亭序》-平稳血压，解烦去燥，助眠",
    "火-《灵气养心》-调整情绪，愉悦心情",
    "火-《茉莉花》半夏药音  火音入心  徵调养心，去燥安神",
    "火-《生生世世爱》-可振奋精神、调整情绪",
    "火-《双面燕洵》-提高情绪状态",
    "火-《雨后彩虹》-徵调阴（心属火）",
    "火-《紫竹调》-静心养心曲",
    "金-《古琴音药》-养肺平衡肺气",
    "金-《云凝.肺脏养生乐》-平肺气宁心",
    "金-《云凝.肺脏养生乐》-平衡肺气提高免疫",
    "金-《静空》-五行相生滋养",
    "金-《金音养肺》-平肺气疏气脉",
    "金-《净化排毒》-排毒疏通气脉",
    "金-《任逍遥》-润肺健脾养心",
    "金-《商音养肺》-养肺平衡肺气",
    "金-《开悟》-疏肝养肺平气血",
    "金-《春江花月夜》-养肺护肺提高免疫力",
    "金-《商音养肺》-补元气平肺气",
    "金-《静心》-净心助眠安神涤念",
    "金-《断桥残雪》提高情绪状态和心理幸福感，助于改善集中力",
    "金-《古筝禅境》用脑过度，宁心净脑，缓解疲劳",
    "金-《鸿迹》调节内分泌系统，促进睡眠，缓解压力",
    "金-《花好月圆夜》提高情绪状态",
    "金-《花月本无常》缓解疲劳",
    "金-《化蝶》提高免疫力，宁心净脑",
    "金-《可可托海的牧羊人》养元贮能，调畅气机",
    "金-《乱红》消除压力，治愈",
    "金-《秋风过耳》调畅气机，增强免疫",
    "金-《秋风醉》宁心净脑，用脑过度兴奋不已适听，运动后放松消除疲劳宜听",
    "金-《秋月清露》-商调阴（肺属金）",
    "金-《任逍遥》工作劳累需听用曲，缓解疲劳",
    "金-《晚霞钟鼓》-商调阳（肺属金）",
    "金-《夕阳箫鼓》琵琶演奏",
    "金-《潇湘水云》经常用脑，多听",
    "金-《一花一剑》养元贮能",
    "金-《紫气东来》调畅气机，脑力劳动者需多听用",
    "木-《胡笳十八拍》-角调疏肝养肝",
    "木-《商音养肺》-平衡肺气提高免疫力",
    "木-《清净法身佛》-调理气机平和气血",
    "木-《腐草为萤》-疏肝养肾健脾",
    "木-《太极》-疏肝补肾养心安神",
    "木-《清溪潺流》-疏肝畅气养心安神",
    "木-《楚歌》-角调疏肝养身",
    "木-《双鹤听泉》-解肝郁理肝气",
    "木-《天涧.肾脏养生乐》-养心补肾健脑",
    "木-《吹梦到西洲》解郁安神，平息怒火",
    "木-《吹箫人去玉楼空》疏肝畅气，解忧减压",
    "木-《春花秋月梦一场》调整情绪，心情低落等可以常听",
    "木-《春来花自放》疏肝理气",
    "木-《凤求凰》解肝郁，疏肝气",
    "木-《观心自在》胆小、多疑、失眠可常听",
    "木-《胡笳十八拍》角调疏肝 烦燥胸闷，抑郁失眠",
    "木-《兰香涧》夜间听有助于安魂入睡，放松，冥想，治愈",
    "木-《了然于心》有助于缓解压力，焦虑失眠",
    "木-《弥陀心印》解郁安神",
    "木-《茗香》舒心畅气，美丽心情",
    "木-《墨缘》舒心畅气，缓解焦虑，养元赋能",
    "木-《涅槃》有失眠多梦者可常听用",
    "木-《清明雨上》释放压力",
    "木-《山水间》愉悦心情，放松解压",
    "木-《水》解郁忘忧  平和心态",
    "木-《水墨兰亭》解郁忘忧，放松解压",
    "木-《溪行桃花源》助益睡眠，情绪低落常听",
    "木-《夏雨风荷》胆小多疑，失眠",
    "木-《闲庭絮》增强精神，消除失眠",
    "木-《一花一世界》释放压力",
    "木-《知音》放松解压-古筝",
    "木-《止于至善》舒心畅气，放松减压",
    "木-《碧叶烟雨》-角调阴（肝属木）",
    "木-《玄天暖风》-角调阳(肝属木)",
    "木-《半山听雨》抑制兴奋，身体劳累者，恢复体力",
    "水-《春来花自放》-丝弦养心羽音安神",
    "水-《养肾最佳曲目》-强肾养肾养身",
    "水-《归来》-强肾养心安神",
    "水-《羽音养肾》-平心静气提神醒脑",
    "水-《春来》-滋补肾精入肾",
    "水-《神话》-养心安神补肾",
    "水-《痴情冢》-养肾护肝养心",
    "水-《不惜时光》二胡",
    "水-《痴情冢》宁心静脑，缓解疲劳",
    "水-《归来》镇静安神-古琴",
    "水-《红颜旧》缓解疲劳，恢复体力，经常熬夜适听",
    "水-《金陵遗梦》释放压力",
    "水-《绿野仙踪》经常熬夜适听",
    "水-《梅花泪》宁心净脑，缓解疲劳",
    "水-《梅花三弄》最佳养肾曲目",
    "水-《琵琶语》助益睡眠，经常熬夜需多听",
    "水-《片片相赋予谁》缓解疲劳，注意力不集中，记忆力差",
    "水-《平沙落雁》养肾藏精润燥 静心养神安神",
    "水-《普庵咒》古琴曲",
    "水-《千年一叹》解疲劳，助益睡眠",
    "水-《三寸天堂》宁心净脑，镇静安神",
    "水-《卧龙吟》缓解疲劳，助益睡眠",
    "水-《乌兰巴托的夜》增强记忆，缓解疲劳，脾气大",
    "水-《无羁》强肾降火，镇静，舒缓压力",
    "水-《寻常歌》经常熬夜，烦躁不安",
    "水-《檐下雨意》帮助人们缓解身体的疼痛和不适感",
    "水-《养生乐羽入肾》脾气急燥者可多听，易受惊吓",
    "水-《忆江南》利于放松入静，促进睡眠，消除疲劳",
    "水-《雨碎江南》记性差、火气大",
    "水-《冰雪寒天》-羽调阴（肾属水）",
    "水-《伏阳朗照》-羽调阳（肾属水）",
    "土-《松涛声远》-养脾舒神静心",
    "土-《水寒烟》-宫调养脾舒神静心",
    "土-《脾肾养生》-健脾调整气机",
    "土-《秋去》-稳情绪疏肝理气",
    "土-《先天滋补》-健脾羽调益肾",
    "土-《平沙落雁》-养脾滋补身心",
    "土-《逐梦令》-滋养气血养心",
    "土-《茶香白云飘》-修身养性护肝",
    "土-《千年风雅》-调整气机改善肤色",
    "土-《合和.脾脏养生乐》-健脾养胃护肝",
    "土-《大鱼》-养脾合胃静心",
    "土-《暗香》安稳身心",
    "土-《半城烟沙》饭后多听，安定情绪",
    "土-《尘》缓解焦虑紧张",
    "土-《穿越时空的思念》调整情绪，脸色不好、失眠、胃酸胀痛适听",
    "土-《春暮花落雨》缓解焦虑-陶笛",
    "土-《大鱼》若茶饭不思或暴饮暴食可常听用",
    "土-《故梦》有暴饮暴食或食欲不振者可常听用",
    "土-《故土》眠，暴饮暴食，或者茶饭不思适听，缓解焦虑",
    "土-《黄庭骄阳》-宫调阳（脾属土）",
    "土-《空山静》胃不好必听的养胃曲",
    "土-《追梦》安稳心理，缓解焦虑",
    "土-《神话》安稳身心，助益睡眠",
    "土-《天空之城》助益睡眠，气色不佳，焦虑失眠适用",
    "土-《星河叹》改善面色、失眠",
    "土-《烟雨唱扬州》安稳身心，缓解焦虑",
    "土-《一念千年》保肺气，利肾水",
    "土-《幽》脾喜音乐，提高食欲，促进消化",
    "土-《幽古》调整情绪-古埙演奏",
    "土-《玉液还丹》-宫调阴（脾属土）",
    "土-《愿作菩萨那朵莲》缓解焦虑",
    "土-《月夜风清》养脾健胃",
    "土-《知否知否》安稳身心，缓解焦虑"
}